import http from '~/utils/http'
import type { HttpResponse, RequestConfig } from '~/types/http'

/**
 * 套餐列表
 * /crami/queryAllPackage_hw 
 */
export async function queryAllPackage(config?: Partial<RequestConfig>): Promise<HttpResponse<{id: number, name: string, html: string, html2: string, price: number }>> {
  return http.get('/crami/queryAllPackage_hw', {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 下单
 * @param params goodsId 套餐 id
 * @param params success_url 支付成功跳转网址
 * @returns orderId 订单id
 * @returns url 支付链接
 */
export async function placeOrder(params: { goodsId: number, success_url: string, event_id?: string }, config?: Partial<RequestConfig>): Promise<HttpResponse<{ orderId: string, url: string }>> {
  return http.post('/order/buy_hw', params, {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 取消订阅
 */
export async function unsubscribe(config?: Partial<RequestConfig>) {
  return http.post('/pay/cancel_stripe_subscription', {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 恢复订阅
 */
export async function restoreSubscription(config?: Partial<RequestConfig>) {
  return http.post('/pay/renew_stripe_subscription', {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 降级订阅
 */
export async function downgradeSubscription(params: { goodsId: number }, config?: Partial<RequestConfig>): Promise<HttpResponse<boolean>> {
  return http.post('/pay/downgrade_stripe_subscription', params, {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 升级订阅
 */
export async function upgradeSubscription(params: { goodsId: number }, config?: Partial<RequestConfig>): Promise<HttpResponse<boolean>> {
  return http.post('/pay/upgradeSubscription', params, {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 取消降级
 */
export async function cancelDowngrade(config?: Partial<RequestConfig>): Promise<HttpResponse<boolean>> {
  return http.post('/pay/cancel_downgrade_stripe_subscription', {
    showSuccess: true,
    loading: true,
    ...config
  })
}

/**
 * 获取升级订阅价格
 * @param params goodsId 套餐id
 * @returns oldPrice 原价
 * @returns remainingPrice 抵扣
 * @returns price 支付价格
 */
export async function upgradeSubscriptionPrice(params: { goodsId: string }, config?: Partial<RequestConfig>): Promise<HttpResponse<{ oldPrice: number, remainingPrice: number, price: number }>> {
  return http.post('/pay/upgradeSubscriptionPrice', params, {
    showSuccess: true,
    loading: true,
    ...config
  })
}
